import { lambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { apiBaseUrl } from '@/pages/OperationsAdministration/services/constants';
import { WorkstreamDefinitionOperationConfigPatch } from '@/pages/OperationsAdministration/types/Api/WorkstreamDefinitionOperationConfigPatch';

export async function patchWorkstreamDefinitionOperationConfig(
    id: number,
    patch: WorkstreamDefinitionOperationConfigPatch
) {
    const patchUrl = `${apiBaseUrl}/${id}`;

    const body = JSON.stringify(patch);
    const opts = { headers: { 'Content-Type': 'application/json' } } as RequestInit;

    await lambda.patch(patchUrl, body, opts);
}